import { checkKorDeparture, medicalPassportValidate } from '@/api';
import LoadingView from '@/components/common/LoadingView';
import { routes } from '@/constant/routes.const';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { isRefundableAirport } from '@repo/utils';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';

type ParamProps = {
  passportNumber: string;
};

function PassportRedirect() {
  const { passportNumber } = useParams() as ParamProps;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryString = new URLSearchParams(location.search);
  const targetPath = queryString.get('path');

  const { mutate: getKorDeparture } = useMutation(
    () => checkKorDeparture(passportNumber),
    {
      onSuccess: ({ isDepartureCheckRequired }) => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            isDepartureCheckRequired,
          },
        });
      },
    },
  );

  const { mutate: varifiedPassport } = useMutation(
    (payload: string) => medicalPassportValidate(payload),
    {
      retry: false,
      onSuccess: ({
        departureDate,
        customerNation,
        isAirportRefundable,
        ...rest
      }) => {
        if (customerNation === 'KOR') getKorDeparture();
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            passportNumber,
            nationality: customerNation,
            ...rest,
          },
        });
        departureDate &&
          localStorage.setItem('medicalDepartureDate', departureDate);
        customerNation &&
          localStorage.setItem('medicalCustomerNation', customerNation);
        localStorage.setItem('login', passportNumber!);

        if (targetPath?.includes('inquiry')) {
          return history.push(`/${targetPath}`);
        }

        if (isAirportRefundable) {
          const isTransferWeb = localStorage.getItem(
            `${passportNumber}-transfer`,
          );
          if (isTransferWeb === 'true') {
            if (departureDate) {
              history.push({
                pathname: routes.medicalHome,
              });
            } else {
              history.push({
                pathname: routes.medicalDeparture,
              });
            }
            return;
          }

          const selectedAirport = localStorage.getItem(passportNumber);
          if (!selectedAirport)
            return history.push(routes.medicalSelectAirport);
          if (isRefundableAirport(selectedAirport)) {
            return history.push(routes.medicalAirport);
          }
        }
        history.push(`/${targetPath}`);
      },
    },
  );

  useEffect(() => {
    varifiedPassport(passportNumber!);
  }, [passportNumber]);

  return (
    <LoadingWrapper>
      <LoadingView />
    </LoadingWrapper>
  );
}

export default PassportRedirect;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
